import React, { Component } from 'react';
import utilFunction from '../../containers/function';
import strings from '../locales/';
import BarChart from '../common/graphs/crossfilterGraphs/barChart';

const FlowsByCategoryTagsHistogramGraph = props => {
  var tagAux = props.labels;

  if(tagAux && tagAux.length==1) {
    tagAux[1] = tagAux[0];
    tagAux[0] = {tag: " "};    
    tagAux[2] = {tag: "  "};
  }

  return (
    <div id="flows-by-category-tags-histogram-graph" className="dc-chart-parent">
      <BarChart
        id={'flows-by-category-tags-histogram-graph-component'}
        additionalCrossfilterData={null}
        crossfilerData={utilFunction.generateCrossfilter(props.data)}
        stack={false}
        dimension={{
          formatFunction: [],
          name: 'label',
          originalName: 'label',
          reduceFunction: {
            type: 'DISCRETE_GROUP',
            typeof: 'STRING',
            parameters: {
              categoriesParser: [],
              categories: tagAux.map(item => {
                return [{value: item.tag, operator: '=='}];
              }),
              labels: tagAux.map(item => {
                return item.tag;
              }),
            }
          }
        }}
        metrics={[
          {
            config: {},
            filter: [],
            formatFunction: [],
            metric: 'countExecuted',
            name: 'Realizado',
            reduceFunction: { type: 'AVG' },
            type: 'AVG'
          },
          {
            config: {},
            filter: [],
            formatFunction: [],
            metric: 'countPlanned',
            name: 'Planificado',
            reduceFunction: { type: 'AVG' },
            type: 'AVG'
          }
        ]}
        config={{
          horizontal: false,
          legend: true,
          tooltip: {
            valuesConfig: [
              {
                identifier: 'layer',
                valueFormat: { type: 'STRING', format: '' },
                wrapper: `<div>${"Estatus:"}<span style='font-weight: bold;'> %v</span></div>`
              },
              {
                identifier: 'x',
                valueFormat: { type: 'STRING', format: '' },
                wrapper: `<div>${"Transportista:"}<span style='font-weight: bold;'> %v</span></div>`
              },
              {
                identifier: 'y',
                valueFormat: { type: 'NUMBER', format: 'd' },
                wrapper: `<div>${"Cantidad:"}<span style='font-weight: bold;'> %v</span></div>`
              }
            ]
          },
          gap: 80,
          colors: ['#4E8ED5','#6AB386'],
          xAxis: { labelPadding: 30, rotation: -20, label: 'Transportista' },
          yAxis: { show: true, format: '.0f', ticksNumber: 3, label: 'Cantidad'  }
        }}
        dashboardId={'flow_admin_rca_reports'}
      />
    </div>
  );
}

export default FlowsByCategoryTagsHistogramGraph;



// WEBPACK FOOTER //
// ./source/client/components/flow_admin_rca_reports/flowsByCategoryTagsHistogramGraph.jsx